import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';

import { IPortalELearning } from '../actions/portal';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		eLearningTitle: {
			color: theme.palette.primary.main,
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		elTableCell: {
			wordBreak: 'keep-all',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
			display: 'inline-block',
			wordBreak: 'break-word',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
	});

interface IPortalNoticeTableRowProps {
	eLearning: IPortalELearning;
	errorMessageJukouStatusSinseiDialogOpen: () => void;
	handleShowDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
	handleTrainingClick: (e: React.MouseEvent<HTMLElement>) => void;
}
interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		IPortalNoticeTableRowProps {}

/**
 * お知らせ行コンポーネント
 * @param props
 */
const PortalNoticeTableRow: React.FC<IProps> = props => {
	const {
		classes,
		eLearning,
		handleShowDetailDialog,
		handleTrainingClick,
	} = props;

	let openTimes: string;
	// 受講期間がnullの場合、画面上空白で表示する
	if (eLearning.showOpenStartDate && eLearning.showOpenEndDate) {
		openTimes = `${eLearning.showOpenStartDate} ${i18n.t(
			'PortalNoticeCard_0001'
		)} ${eLearning.showOpenEndDate}`;
	} else {
		openTimes = '';
	}

	return (
		<TableRow>
			<TableCell className={classes.elTableCell} style={{ width: '15%' }}>
				{eLearning.aplType !== 0 &&
					(eLearning.contentFlg === 1 ||
						eLearning.enqueteFlg === 1 ||
						eLearning.reportFlg === 1) &&
					eLearning.externalCourseType !== 1 && (
						<Button
							size="small"
							color="primary"
							variant="contained"
							onClick={handleTrainingClick}
						>
							{i18n.t('PortalNoticeTableRow_0003')}
						</Button>
					)}
				{eLearning.aplType !== 0 &&
					(eLearning.contentFlg === 1 ||
						eLearning.enqueteFlg === 1 ||
						eLearning.reportFlg === 1) &&
					eLearning.externalCourseType === 1 && (
						<Button
							size="small"
							color="default"
							variant="contained"
							onClick={handleTrainingClick}
						>
							{i18n.t('PortalNoticeTableRow_0002')}
						</Button>
					)}
			</TableCell>
			<TableCell style={{ width: '35%' }}>
				<span
					className={classes.link}
					data-careerid={eLearning.careerID}
					onClick={handleShowDetailDialog}
				>
					{eLearning.title}
				</span>
			</TableCell>
			<TableCell style={{ width: '10%' }}>
				<Progress progress={eLearning.progress} />
			</TableCell>
			<TableCell>{openTimes}</TableCell>
		</TableRow>
	);
};

const Progress: React.FC<{ progress: string }> = props => {
	if (/^(\-|\+)?([0-9]+)$/.test(props.progress) === false) {
		return <div style={{ height: 20 }}>{props.progress}</div>;
	}

	const progress = +props.progress;
	return (
		<div
			style={{
				backgroundColor: '#dadada',
				borderRadius: '2px',
				display: 'inline-block',
				height: 20,
				width: '100%',
			}}
		>
			<div
				style={{
					backgroundColor:
						progress > 66
							? '#85cc00'
							: progress > 33
							? '#ffbf00'
							: '#ff2e00',
					borderRadius: '2px',
					display: 'inline-block',
					height: '100%',
					transition: 'all .2s ease-out',
					width: `${progress}%`,
				}}
			>{`${progress}%`}</div>
		</div>
	);
};

export default withStyles(styles)(PortalNoticeTableRow) as React.ComponentClass<
	IPortalNoticeTableRowProps
>;



// WEBPACK FOOTER //
// ./src/components/PortalNoticeTableRow.tsx